import styled from 'styled-components/macro';
import styles from 'src/styles/vars.module.scss';

export const GraphButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  position: absolute;
  height: 22px;
  top: 4px;
  right: 4px;
  justify-content: flex-end;
  gap: 10px;
`;

export const ProfileGraphButton = styled.div`
  z-index: 3;

  button.bp3-button.bp3-intent-primary.track-profiles-btn.mosaic-button.compact {
    border-radius: 100px;
    font-size: 11px;
    background: ${styles.brandDarkened};
  }
`;

export const GateDeviationGraphButton = styled.div`
  z-index: 3;

  button.bp3-button.bp3-intent-primary.gate-deviation-btn.mosaic-button.compact {
    border-radius: 100px;
    font-size: 11px;
    background: ${styles.brandDarkened};
  }
`;
